import React, {MutableRefObject} from "react";
import styles from "./SectionWrapper.module.css";
import Box from "@mui/material/Box";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import useSociety from "../../hooks/useSociety";
import UseDataPut from "../../hooks/useDataPut";
import {SectionDTO} from "../../pages/society/homepage/SocietyHomepage";

interface SectionWrapperProps {
    section: React.ReactNode;
    sectionRef: MutableRefObject<HTMLDivElement | null>,
    backgroundColor: string,
    isFirst: boolean,
    isLast: boolean,
    sectionId: number,
}

const SectionWrapper = ({section, sectionRef, backgroundColor, isFirst, isLast, sectionId}: SectionWrapperProps) => {

    const {society} = useSociety();

    const {putDataPromise} = UseDataPut<SectionDTO>(`/societies/${society.id}/sections/${sectionId}`, {}, true, false, false);

    const handleChangeOrder = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>, downwards: boolean) => {
        e.preventDefault();
        putDataPromise(undefined, {downwards: downwards})
            .then((response) => {
                window.location.reload();
            })
    }

    return (
        <Box
            className={styles.outerBox}
            ref={sectionRef}
            sx={{
                backgroundColor: backgroundColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
            }}
        >

            {society.secured && !(isFirst && isLast) && (
                <>
                    {!isFirst && (
                        <Box
                            className={styles.sectionActionsTop}
                        >
                            <Tooltip title="Monter la section">

                                <IconButton
                                    aria-label="Upward"
                                    variant="secondVariant"
                                    onClick={(e) => handleChangeOrder(e, false)}
                                >
                                    <ArrowUpward sx={{
                                        fontSize: {xs: '18px', sm: '20px'}
                                    }}/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {!isLast && (
                        <Box
                            className={styles.sectionActionsBottom}
                        >
                            <Tooltip title={"Descendre la section"}>
                                <IconButton
                                    aria-label="Downward"
                                    variant="secondVariant"
                                    onClick={(e) => handleChangeOrder(e, true)}
                                >
                                    <ArrowDownward sx={{
                                        fontSize: {xs: '18px', sm: '20px'}
                                    }}/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                </>
            )}
            {section}
        </Box>
    );
}

export default SectionWrapper